'use client';

import { useState } from 'react';
import { supabase } from '@/lib/db/supabase';

export function useEmailValidation() {
  const [isChecking, setIsChecking] = useState(false);
  const [emailExists, setEmailExists] = useState(false);

  const checkEmail = async (email: string) => {
    if (!email || !email.includes('@')) {
      setEmailExists(false);
      return;
    }
    
    setIsChecking(true);
    try {
      const { data, error } = await supabase
        .rpc('check_email_exists', { email_address: email });

      if (error) throw error;
      setEmailExists(!!data);
    } catch (error) {
      console.error('Erro ao verificar email:', error);
      setEmailExists(false);
    } finally {
      setIsChecking(false);
    }
  };

  return {
    isChecking,
    emailExists,
    checkEmail
  };
}